// MD2 PRO
import MDBox from 'components/MDBox';

// Components
import FileViewGoogleDrive from 'components/General/File/FileViewGoogleDrive';
import SummaryCard from 'layouts/production/Components/AaroComponents/SummaryCard';

// Helpers
import { formatPrice } from 'helpers/priceHelpers';
import { formatDate } from 'helpers/dateHelpers';

// Constants
import { config } from 'Constants';

const { GOOGLE_DRIVE_ORDER_FILES_FOLDER_ID } = config.fixedID;

function SidebarRight({ production, relatedID, aaroQueries }) {
    // Guard clause to prevent errors when production data isn't available
    if (!production) {
        return null;
    }

    const { orderDetailsQuery } = aaroQueries;
    const orderDetails = orderDetailsQuery?.data?.[0] || {};

    const {
        KartAdi,
        OlsTar,
        UretimOrani,
        SevkiyatOrani,
        Tutar,
        TutarDvz,
        DovizKodu,
        BelgeNo,
        DekontID,
        CariID,
        OlsAdi,
    } = orderDetails;

    // Calculate how many days ago the order was created
    const daysOrderCreated = Math.floor((new Date() - new Date(OlsTar)) / (1000 * 60 * 60 * 24));

    const getURL = (type, id, name) => {
        const url = `https://erp.aaro.com.tr/${type}?id=${id}`;
        return (
            <a href={url} target="_blank" rel="noreferrer">
                {name}
            </a>
        );
    };

    // Helper function to render order details
    const renderOrderSummary = () => (
        <SummaryCard
            title="Sipariş Özeti"
            subtitle={` ${daysOrderCreated} gün önce, ${OlsAdi} tarafından oluşturuldu.`}
            truncateValues={true}
            items={{
                Sipariş: getURL('DekontFatura/Kalem', DekontID, BelgeNo),
                Müşteri: getURL('Cari/Ozet', CariID, KartAdi),
                Tutar: `${formatPrice(Tutar || 0)}`,
                'Tutar Döviz': `${formatPrice(TutarDvz || 0, DovizKodu)}`,
                'Üretim Oranı': `%${UretimOrani || 0}`,
                'Sevkiyat Oranı': `%${SevkiyatOrani || 0}`,
                Tarih: formatDate(OlsTar),
            }}
            showPrintIcon={true}
            customIcon="receipt"
        />
    );

    // Helper function to render production files section
    const renderProductionFiles = () => (
        <FileViewGoogleDrive
            folderId={GOOGLE_DRIVE_ORDER_FILES_FOLDER_ID}
            getOrCreate={true}
            getOrCreateFolderName={relatedID}
            documents={['01_Ölçü ve Çizimleri', '02_CNC Dosyaları', '03_Teslimat ve Kalite']}
            topName={'Üretim Dosyaları'}
        />
    );

    return (
        <>
            <MDBox mb={2}>{renderOrderSummary()}</MDBox>

            {/* Üretim Dosyaları */}
            <MDBox mb={2}>{renderProductionFiles()}</MDBox>
        </>
    );
}

export default SidebarRight;
